/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CompleteBindingRefreshRequestBody = {
  attemptId: string;
  principalId: string;
  userSessionIssuerId: string;
};

/** @internal */
export type CompleteBindingRefreshRequestBody$Outbound = {
  attempt_id: string;
  principal_id: string;
  user_session_issuer_id: string;
};

/** @internal */
export const CompleteBindingRefreshRequestBody$outboundSchema: z.ZodMiniType<
  CompleteBindingRefreshRequestBody$Outbound,
  CompleteBindingRefreshRequestBody
> = z.pipe(
  z.object({
    attemptId: z.string(),
    principalId: z.string(),
    userSessionIssuerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      attemptId: "attempt_id",
      principalId: "principal_id",
      userSessionIssuerId: "user_session_issuer_id",
    });
  }),
);

export function completeBindingRefreshRequestBodyToJSON(
  completeBindingRefreshRequestBody: CompleteBindingRefreshRequestBody,
): string {
  return JSON.stringify(
    CompleteBindingRefreshRequestBody$outboundSchema.parse(
      completeBindingRefreshRequestBody,
    ),
  );
}
